import { PlainRoute } from 'react-router';
import { SetRouteParamsAction, RouteParamsActionKeys } from './actions';
import Utils from '../../utils';

export interface RouterParamsState {
	params: { [k: string]: string };
	routes: PlainRoute[];
}

const initialState = [];

export function routerParamsHistory(state: RouterParamsState[] = initialState, action: SetRouteParamsAction): RouterParamsState[] {
	switch (action.type) {
		case RouteParamsActionKeys.SET_ROUTE_PARAMS:
			return [
				...state, {
					params: Utils.deepCopy(action.data),
					routes: Utils.deepCopy(action.routes)
				}
			];
		default:
			return state;
	}
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/SetRouteParams/reducer.ts